function toNumber(value) {
    const parsedValue = Number(value ?? 0);

    return Number.isFinite(parsedValue) ? parsedValue : 0;
}

function hasValue(value) {
    return value !== null && value !== undefined && value !== '';
}

function targetTotal(invoice) {
    if (hasValue(invoice.total_value_target)) {
        return invoice.total_value_target;
    }

    if (hasValue(invoice.total_target_value)) {
        return invoice.total_target_value;
    }

    if (hasValue(invoice.total_target)) {
        return invoice.total_target;
    }

    return invoice.total_value;
}

/**
 * Returns the invoice total minus payments and credits.
 * Uses target-currency values when available and applies a purchase-order pivot allocation when present.
 */
export function totalOutstanding(invoice, target = true) {
    const useTargetValues = target && !!invoice.target_currency;
    const totalValue = useTargetValues ? targetTotal(invoice) : invoice.total_value;
    const paidValue = useTargetValues ? invoice.total_paid_target : invoice.total_paid;
    const creditValue = useTargetValues ? invoice.total_credit_target : invoice.total_credit;
    const outstanding = toNumber(totalValue) - toNumber(paidValue) - toNumber(creditValue);
    const roundedOutstanding = useTargetValues ? Number(outstanding.toFixed(2)) : Math.ceil(outstanding * 100) / 100;
    const valueModifier = Number(invoice.pivot?.value_modifier);

    if (invoice.pivot && Number.isFinite(valueModifier) && valueModifier < 100) {
        return (valueModifier / 100) * roundedOutstanding;
    }

    return roundedOutstanding;
}

/**
 * Used in ObjectDataTable to calculate the net amount of awaiting invoices for a given row.
 * @param ObjectDataRow
 * @returns {number|number}
 */
export function amountNotInvoiced(ObjectDataRow) {
    const awaitingInvoice = ObjectDataRow.subtotal - ObjectDataRow.total_invoiced ?? 0;
    return awaitingInvoice > 0 ? awaitingInvoice : 0;
}
